import React from 'react';
import PropTypes from 'prop-types';
import IncentivesMessage from './IncentivesMessage';
import StandardPriceGroup from './StandardPriceGroup';
import TotalVehicleAndOptionsGroup from './TotalVehicleAndOptionsGroup';
import PackageGroup from './PackageGroup';
import TotalPriceAndDiscountsGroup from './TotalPriceAndDiscountsGroup';
import IncentivesGroup from './IncentivesGroup';
import NetPriceGroup from './NetPriceGroup';
import TotalDiscountGroup from './TotalDiscountGroup';
import EVIncentivesGroup from './EVIncentivesGroup';
import FamilyFirstIneligibleMessage from './FamilyFirstIneligibleMessage';
import AccessoriesGroup from './AccessoriesGroup';
import TotalEmployeePriceGroup from './TotalEmployeePriceGroup';

const MathBoxWrapper = ({ children }) => (
  <div className="math-box">{children}</div>
);

const MathBox = props => {
  const {
    isFamilyFirstUS,
    isFamilyFirstCA,
    pricing,
    country,
    eventName,
    inlineIncentives,
    isSummary,
    eligibleForInvoicePrice,
    children
  } = props;

  const isUnitedStates = country === 'US';
  const isCanada = country === 'CA';
  const isBrazil = country === 'BR';

  if (isBrazil) {
    return (
      <MathBoxWrapper>
        <IncentivesMessage pricing={pricing} isSummary={isSummary} />
        <StandardPriceGroup pricing={pricing} isSummary={isSummary} />
        {children}
        <TotalVehicleAndOptionsGroup pricing={pricing} />
        <PackageGroup pricing={pricing} />
        <TotalPriceAndDiscountsGroup pricing={pricing} eventName={eventName} />
        <TotalEmployeePriceGroup pricing={pricing} />
        <TotalDiscountGroup pricing={pricing} />
        <EVIncentivesGroup pricing={pricing} />
        <AccessoriesGroup pricing={pricing} isSummary={isSummary} />
      </MathBoxWrapper>
    );
  }

  if (isCanada) {
    return (
      <MathBoxWrapper>
        <IncentivesMessage pricing={pricing} isSummary={isSummary} />
        <StandardPriceGroup pricing={pricing} isSummary={isSummary} />
        {children}
        <TotalVehicleAndOptionsGroup
          pricing={pricing}
          isSummary={isSummary}
          isFamilyFirst={isFamilyFirstUS || isFamilyFirstCA}
        />
        <PackageGroup pricing={pricing} />
        <IncentivesGroup
          pricing={pricing}
          inlineIncentives={inlineIncentives}
          isSummary={isSummary}
          isCanada={isCanada}
        />
        <NetPriceGroup
          pricing={pricing}
          isSummary={isSummary}
          eventName={eventName}
          isCanada
        />
        <EVIncentivesGroup pricing={pricing} />
        <FamilyFirstIneligibleMessage
          eligibleForInvoicePrice={eligibleForInvoicePrice}
        />
        <AccessoriesGroup pricing={pricing} isSummary={isSummary} />
      </MathBoxWrapper>
    );
  }

  return (
    <MathBoxWrapper>
      <IncentivesMessage pricing={pricing} isSummary={isSummary} />
      <StandardPriceGroup pricing={pricing} isSummary={isSummary} />
      {children}
      <TotalVehicleAndOptionsGroup pricing={pricing} />
      <PackageGroup pricing={pricing} />
      <TotalPriceAndDiscountsGroup
        pricing={pricing}
        eventName={eventName}
        ruled
        isUnitedStates={isUnitedStates}
      />
      <TotalEmployeePriceGroup
        pricing={pricing}
        eventName={eventName}
        isUnitedStates={isUnitedStates}
      />
      <NetPriceGroup
        isFamilyFirstUS={isFamilyFirstUS}
        pricing={pricing}
        isSummary={isSummary}
        eventName={eventName}
      />
      <TotalDiscountGroup pricing={pricing} isUnitedStates />
      <EVIncentivesGroup pricing={pricing} />
      <FamilyFirstIneligibleMessage
        eligibleForInvoicePrice={eligibleForInvoicePrice}
      />
      <AccessoriesGroup pricing={pricing} isSummary={isSummary} />
    </MathBoxWrapper>
  );
};

MathBox.propTypes = {
  pricing: PropTypes.object,
  isSummary: PropTypes.bool,
  inlineIncentives: PropTypes.bool,
  eligibleForInvoicePrice: PropTypes.bool,
  country: PropTypes.string
};

export default MathBox;
